import styled, { keyframes } from "styled-components";

const bubbleToCorner = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  25% {
    transform: translate(-50%, -50%) scale(1.12);
    opacity: 1;
  }
  100% {
    transform: translate(calc(-50% + 50vw - 4rem - 40px), calc(-50% + 50vh - 4rem - 40px)) scale(0.25);
    opacity: 0;
  }
`;

export const TransitionOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.88);
  z-index: 8000;
`;

export const TransitionBubble = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #021526;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 32px rgba(2, 21, 38, 0.35);
  z-index: 8001;
  animation: ${bubbleToCorner} 0.7s cubic-bezier(0.4, 0, 0.2, 1) forwards;

  img {
    width: 48px;
    height: 48px;
    object-fit: contain;
    filter: brightness(0) invert(1);
  }
`;

export const ChatViewWrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0;
  padding: 0;
  background: #ffffff;
  position: relative;
  overflow-y: auto;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    padding: 1rem 0 0;
    height: 100%;
    margin-top: 0;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
`;

export const ChatWrapper = styled.div`
  height: 100%;
  width: 100%;
  max-width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;
  padding: 0;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  width: 100%;
  margin-bottom: ${(props) => props.theme.spacing.large};
  margin-top: 0;
  flex-shrink: 0;
  > img {
    height: 5rem;
    width: 5rem;
    opacity: 1;
    display: block !important;
    object-fit: contain;
    visibility: visible !important;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    margin-bottom: 0.5rem;
    margin-top: 0;
    > img {
      height: 2.5rem;
      width: 2.5rem;
    }
  }
`;

export const PreviewTitle = styled.h1`
  font-size: 2rem;
  font-weight: 400;
  color: ${(props) => props.theme.colors.font.primary};
  text-align: center;
  margin: 0;
  margin-bottom: ${(props) => props.theme.spacing.xlarge};
  line-height: 1.4;
  width: 100%;
  flex-shrink: 0;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 1.125rem;
    margin-bottom: 0.75rem;
    line-height: 1.3;
  }
`;

export const PreviewInputWrapper = styled.div`
  width: 100%;
  max-width: 768px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 24px;
  box-shadow: none;
  transition: all 0.2s;
  padding: 0.75rem 1rem;
  gap: 0.5rem;
  margin: 0 auto;
  flex-shrink: 0;

  @media (max-width: ${(props) => props.theme.breakpoints.xl}) {
    max-width: 100%;
  }

  &:focus-within {
    border-color: rgba(0, 0, 0, 0.3);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  &:has(textarea:disabled) {
    background-color: #f5f5f5;
    border-color: rgba(0, 0, 0, 0.08);
    cursor: not-allowed;
  }

  > button {
    flex-shrink: 0;
    border-radius: 20px;
    padding: 0 !important;
    min-width: 2.5rem;
    min-height: 2.5rem;
    width: 2.5rem;
    height: 2.5rem;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 0 !important;

    > svg {
      color: #ffffff !important;
      margin: 0 !important;
      display: block;
      margin-right: 0 !important;
      scale: 1 !important;
    }
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    max-width: 100%;
    padding: 0.5rem 0.75rem;
    margin-bottom: 0;
  }
`;

export const PreviewInput = styled.textarea`
  flex: 1;
  min-height: 52px;
  max-height: 200px;
  border: none;
  background-color: transparent;
  resize: none;
  padding: 0.5rem 0;
  font-size: ${(props) => props.theme.fontSizes.medium};
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto;
  color: ${(props) => props.theme.colors.font.primary};
  line-height: 1.5;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${(props) => props.theme.colors.font.secondary};
  }

  &:disabled {
    cursor: not-allowed;
    color: #b0b7c3;
    opacity: 0.6;
  }
`;

export const ChatDisplayer = styled.div`
  width: 100%;
  height: 30rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.small};
  background-color: transparent;
  overflow-y: auto;

  > img {
    height: auto;
    width: 20rem;
  }

  > span {
    font-size: ${(props) => props.theme.fontSizes.xlarge};
    font-weight: 200;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    width: 90%;
    > img {
      display: none;
    }
    > span {
      display: none;
    }
  }
`;

export const ChatTopBarWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem 1rem;
  background-color: #ffffff;
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
  position: sticky;
  top: 0;
  z-index: 10;
  height: auto;
  min-height: auto;
`;

export const ChatTopBarTitle = styled.h2`
  font-size: ${(props) => props.theme.fontSizes.medium || "0.9375rem"};
  font-weight: 600;
  color: ${(props) => props.theme.colors.font.primary};
  margin: 0;
  line-height: 1.1;
`;

export const ChatTopBarSubtitle = styled.span`
  font-size: ${(props) => props.theme.fontSizes.xsmall || "0.75rem"};
  color: ${(props) => props.theme.colors.font.secondary};
  font-weight: 400;
  line-height: 1.1;
  margin-top: 0.0625rem;
`;

export const ChatTopBarTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 10px;
  padding-bottom: 0;
`;

export const ChatTopBarExportButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  background-color: transparent;
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 8px;
  color: ${(props) => props.theme.colors.font.primary};
  cursor: pointer;
  transition: all 0.2s;
  width: 2.5rem;
  height: 2.5rem;
  flex-shrink: 0;

  &:hover {
    background-color: ${(props) => props.theme.colors.secondary || "rgba(0, 0, 0, 0.05)"};
    border-color: ${(props) => props.theme.colors.border};
  }

  svg {
    flex-shrink: 0;
  }
`;

export const SuggestionChipsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: center;
  width: 100%;
  max-width: 768px;
  margin: 0.75rem auto 0;
  flex-shrink: 0;

  @media (max-width: ${(props) => props.theme.breakpoints.xl}) {
    max-width: 100%;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    margin-top: 0.5rem;
    gap: 0.375rem;
  }
`;

export const SuggestionChip = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.875rem 0.5rem 0.5rem;
  border: 1px solid #e5e7eb;
  border-radius: 9999px;
  background-color: #ffffff;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.875rem;
  color: #111827;
  font-weight: 500;
  transition: background-color 0.15s, border-color 0.15s, box-shadow 0.15s, transform 0.1s;

  &:hover {
    background-color: #f9fafb;
    border-color: #d1d5db;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  }

  &:active {
    transform: scale(0.97);
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 0.8125rem;
    padding: 0.4rem 0.75rem 0.4rem 0.4rem;
  }
`;

export const SuggestionChipIcon = styled.div<{ $bg: string; $fg: string }>`
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  background-color: ${(props) => props.$bg};
  color: ${(props) => props.$fg};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 1rem;
    height: 1rem;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    width: 1.5rem;
    height: 1.5rem;
    svg { width: 0.875rem; height: 0.875rem; }
  }
`;

export const PreviewDisclaimer = styled.p`
  font-size: ${(props) => props.theme.fontSizes.xsmall || "0.75rem"};
  color: ${(props) => props.theme.colors.font.grey2 || "#999999"};
  margin: 0;
  margin-top: 0.75rem;
  text-align: center;
  line-height: 1.4;
  width: 100%;
  max-width: 768px;
  flex-shrink: 0;

  @media (max-width: ${(props) => props.theme.breakpoints.xl}) {
    max-width: 100%;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    margin-top: 0.375rem;
    font-size: 0.65rem;
    line-height: 1.3;
    padding: 0 0.5rem;
  }
`;

export const PreviewContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
  padding: 2rem;
  min-height: 0;
  flex: 1;

  @media (max-width: ${(props) => props.theme.breakpoints.xl}) {
    max-width: 100%;
    padding: 2rem 0.75rem;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    padding: 0.75rem 0.5rem;
    justify-content: space-between;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    min-height: 100%;
    height: auto;
    overflow: visible;
  }
`;

// Trial Expired Styles
export const TrialExpiredWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 3rem 1.5rem 1.5rem;
  overflow-y: auto;
`;

export const TrialExpiredContent = styled.div`
  width: 100%;
  max-width: 48rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;


export const TrialExpiredTitle = styled.h1`
  font-size: 1.875rem;
  font-weight: 700;
  color: #111827;
  margin: 0;
  margin-bottom: 0.5rem;
  line-height: 1.2;
`;

export const TrialExpiredSubtitle = styled.p`
  font-size: 1.125rem;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
`;

export const TrialExpiredCard = styled.div`
  width: 100%;
  position: relative;
  z-index: 20;
  background-color: #ffffff;
  border-radius: 1rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  border: 1px solid #e5e7eb;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1.5rem;
  margin-bottom: 3rem;
`;

export const TrialExpiredCardIcon = styled.div`
  background-color: #fef2f2;
  padding: 0.75rem;
  border-radius: 9999px;
  color: #ef4444;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  svg {
    width: 3rem;
    height: 3rem;
    position: relative;
    z-index: 1;
  }
`;

export const TrialExpiredCardTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
  margin: 0;
  line-height: 1.2;
`;

export const TrialExpiredCardDescription = styled.p`
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
  line-height: 1.625;
  max-width: 28rem;
`;

export const TrialExpiredButton = styled.button`
  background-color: #0b1b2b;
  color: #ffffff;
  padding: 0.75rem 2rem;
  border-radius: 0.75rem;
  font-weight: 600;
  box-shadow: 0 10px 15px -3px rgba(11, 27, 43, 0.2);
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border: none;
  cursor: pointer;
  font-size: 1rem;

  &:hover {
    background-color: rgba(11, 27, 43, 0.9);
    transform: scale(1.02);
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const TrialExpiredButtonText = styled.span`
  font-weight: 600;
`;

export const TrialExpiredGuarantee = styled.p`
  font-size: 0.75rem;
  color: #9ca3af;
  margin: 0;
  line-height: 1.5;
`;

export const TrialExpiredFeatures = styled.div<{ $interactive?: boolean }>`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  opacity: ${(props) => (props.$interactive ? 1 : 0.5)};
  pointer-events: ${(props) => (props.$interactive ? 'auto' : 'none')};
  filter: ${(props) => (props.$interactive ? 'none' : 'grayscale(0.5)')};
  margin-top: ${(props) => (props.$interactive ? '0.75rem' : '0')};

  @media (max-width: 975px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const TrialExpiredFeatureCard = styled.button<{ $interactive?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem;
  border-radius: 0.75rem;
  border: 1px solid #e5e7eb;
  background-color: ${(props) => (props.$interactive ? '#ffffff' : 'rgba(255, 255, 255, 0.2)')};
  text-align: left;
  cursor: ${(props) => (props.$interactive ? 'pointer' : 'default')};
  font-family: inherit;
  transition: ${(props) => props.$interactive ? 'background-color 0.15s, border-color 0.15s, box-shadow 0.15s, transform 0.1s' : 'none'};

  ${(props) => props.$interactive && `
    &:hover {
      background-color: #f9fafb;
      border-color: #d1d5db;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    }
    &:active {
      transform: scale(0.98);
    }
  `}
`;

export const TrialExpiredFeatureIcon = styled.div`
  padding: 0.625rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

export const TrialExpiredFeatureTitle = styled.span`
  display: block;
  font-weight: 600;
  font-size: 0.875rem;
  color: #111827;
  margin-bottom: 0.25rem;
`;

export const TrialExpiredFeatureDescription = styled.span`
  font-size: 0.75rem;
  color: #6b7280;
  line-height: 1.5;
`;
